define(function (require) {
    "use strict";

    var LE = require("app");
    var Template = require("personalization-web-agent-templates/slaEdit.tmpl");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var positionsUtility = require("personalization-utils/positionsUtility");
    var InputField = require("ui/input-field/InputField");
    var Settings = require("codeTables/settings.json");
    var KpContent = require("ui.components/kpContent/kpContent");

    var SECOND = 1;
    var MINUTE = 60 * SECOND;
    var HOUR = 60 * MINUTE;
    var DAY = 24 * HOUR;

    var MINIMUM_AUTO_CLOSE_IN_SEC = 25 * MINUTE;
    var MAXIMUM_AUTO_CLOSE_IN_SEC = 90 * DAY;

    var SLAEditView = {};

    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        SLAEditView = Marionette.ItemView.extend({
            template: Template,
            className: "sla-edit-container anchor",
            ui: {
                cancelButton: ".cancel-edit",
                saveButton: ".save-edit",
                editContainer: ".edit-container",
                defaultSlaUnitsDropDown: ".default-sla-container .default-time-units",
                urgentSlaUnitsDropDown: ".urgent-sla-container .urgent-time-units",
                firstTimeSlaUnitsDropDown: ".first-time-sla-container .first-time-time-units",
                defaultSla: ".default-sla-container .default-data-value",
                urgentSla: ".urgent-sla-container .urgent-data-value",
                firstTimeSla: ".first-time-sla-container .first-time-data-value",
                autoCloseContainer: ".auto-close-container",
                autoCloseTime: ".auto-close-container .auto-close-data-value",
                autoCloseUnits: ".auto-close-container .auto-close-time-units",
                knowledgePack: ".kp"
            },
            uiComponents: {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_cancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_save"
                    }
                },
                defaultSlaUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.defaultSlaUnitsDropDown",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: "view._getSlaUnitsOptions",
                        selectedOption: "view._getSelectedDefaultSlaUnits",
                        testCollision : true,
                        collisionWithinSelector : ".le .personalization-main-region"
                    }
                },
                urgentSlaUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.urgentSlaUnitsDropDown",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: "view._getSlaUnitsOptions",
                        selectedOption: "view._getSelectedUrgentSlaUnits",
                        testCollision : true,
                        collisionWithinSelector : ".le .personalization-main-region"
                    }
                },
                firstTimeSlaUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.firstTimeSlaUnitsDropDown",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: "view._getSlaUnitsOptions",
                        selectedOption: "view._getSelectedFirstTimeSlaUnits",
                        testCollision : true,
                        collisionWithinSelector : ".le .personalization-main-region"
                    }
                },
                autoCloseUnitsDropDown: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.autoCloseUnits",
                        permutation: Dropdown.PERMUTATION.DRKBG_NIGHT,
                        items: "view._getSlaUnitsOptions",
                        selectedOption: "view._getSelectedAutoCloseUnits",
                        testCollision : true,
                        collisionWithinSelector : ".le .personalization-main-region"
                    }
                },
                defaultSlaInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.defaultSla",
                        permutation: InputField.Permutation.K,
                        theme: InputField.THEME.NIGHT,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedDefaultSla"
                    }
                },
                urgentSlaInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.urgentSla",
                        permutation: InputField.Permutation.K,
                        theme: InputField.THEME.NIGHT,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedUrgentSla"
                    }
                },
                firstTimeSlaInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.firstTimeSla",
                        permutation: InputField.Permutation.K,
                        theme: InputField.THEME.NIGHT,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedFirstTimeSla"
                    }
                },
                autoCloseTimeInput: {
                    type: InputField,
                    options: {
                        el: "view.ui.autoCloseTime",
                        permutation: InputField.Permutation.K,
                        theme: InputField.THEME.NIGHT,
                        maxLength: 4,
                        inputType: InputField.prototype.InputTypeEnum.NaturalNumber,
                        value: "view._getSelectedAutoCloseTime"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "configuring-response-times"
                    }
                }
            },
            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "SLAEditView:initialize. options = " + options);
                this.anchorSelector = options.anchorSelector;
                this.settingsCollection = options.settingsCollection;
            },
            onRender: function () {
                LEPersonalization.logger.info("rendering", "SLAEditView:onRender.");
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.TOP);
                this.$el.css(offset);
                this.ui.editContainer.removeClass("hide");
                this.ui.autoCloseContainer.removeClass("hide");
                this.uiComponents.defaultSlaUnitsDropDown.setSelection(this._getSelectedDefaultSlaUnits(), {silent: true});
                this.uiComponents.urgentSlaUnitsDropDown.setSelection(this._getSelectedUrgentSlaUnits(), {silent: true});
                this.uiComponents.firstTimeSlaUnitsDropDown.setSelection(this._getSelectedFirstTimeSlaUnits(), {silent: true});
                this.uiComponents.autoCloseUnitsDropDown.setSelection(this._getSelectedAutoCloseUnits(), {silent: true});
                this.uiComponents.defaultSlaInput.setValue(this._getSelectedDefaultSla());
                this.uiComponents.urgentSlaInput.setValue(this._getSelectedUrgentSla());
                this.uiComponents.firstTimeSlaInput.setValue(this._getSelectedFirstTimeSla());
                this.uiComponents.autoCloseTimeInput.setValue(this._getSelectedAutoCloseTime());
            },
            onClose: function () {
                LEPersonalization.logger.debug("closing view", "SLAEditView:onClose.");
            },
            isErrorView : function () {
                LEPersonalization.logger.debug("Determines if UI validations pass", "SLAEditView:isErrorView.");
                this.clearError();
                var isError = false;
                if(_.isEmpty(this.uiComponents.defaultSlaInput.getValue())){
                    this.uiComponents.defaultSlaInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.SLA.input.error.label"));
                    isError = true;
                }
                if(_.isEmpty(this.uiComponents.urgentSlaInput.getValue())){
                    this.uiComponents.urgentSlaInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.SLA.input.error.label"));
                    isError = true;
                }
                if(_.isEmpty(this.uiComponents.firstTimeSlaInput.getValue())){
                    this.uiComponents.firstTimeSlaInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.SLA.input.error.label"));
                    isError = true;
                }

                if(_.isEmpty(this.uiComponents.autoCloseTimeInput.getValue())){
                    this.uiComponents.autoCloseTimeInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.SLA.autoClose.error.label"));
                    isError = true;
                }
                else {
                    var autoCloseTime = this.uiComponents.autoCloseTimeInput.getValue();
                    var autoCloseUnit = this.uiComponents.autoCloseUnitsDropDown.getValue();
                    var autoCloseInSec = LE.siteSettings.SlaUnitsSettings.convertOtherUnit2Sec(autoCloseTime, autoCloseUnit);

                    if(autoCloseInSec < MINIMUM_AUTO_CLOSE_IN_SEC || autoCloseInSec > MAXIMUM_AUTO_CLOSE_IN_SEC){
                        this.uiComponents.autoCloseTimeInput.setError(true, LE.translator.translate("LEPersonalization.webAgent.SLA.autoClose.error.label"));
                        isError = true;
                    }
                }

                return isError;
            },
            clearError: function() {
                LEPersonalization.logger.debug("clear errors from fields", "SLAEditView:clearError.");
                this.uiComponents.defaultSlaInput.setError(false);
                this.uiComponents.urgentSlaInput.setError(false);
                this.uiComponents.firstTimeSlaInput.setError(false);
                this.uiComponents.autoCloseTimeInput.setError(false);
            },
            _cancel: function () {
                LEPersonalization.logger.debug("cancel button was pressed", "SLAEditView:_cancel.");
                LEPersonalization.navigateToPageMenu();
            },
            _save: function () {
                LEPersonalization.logger.debug("saving site settings", "SLAEditView:_save.");
                var options = {};
                options[Settings.SETTING_ID.DEFAULT_SLA_UNITS] = this.uiComponents.defaultSlaUnitsDropDown.getValue();
                options[Settings.SETTING_ID.URGENT_SLA_UNITS] = this.uiComponents.urgentSlaUnitsDropDown.getValue();
                options[Settings.SETTING_ID.FIRST_TIME_SLA_UNITS] = this.uiComponents.firstTimeSlaUnitsDropDown.getValue();
                options[Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME] = this.uiComponents.defaultSlaInput.getValue();
                options[Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME] = this.uiComponents.urgentSlaInput.getValue();
                options[Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME] = this.uiComponents.firstTimeSlaInput.getValue();

                var autoCloseTime = this.uiComponents.autoCloseTimeInput.getValue();
                var autoCloseUnit = this.uiComponents.autoCloseUnitsDropDown.getValue();
                options[Settings.SETTING_ID.AUTO_CLOSE_TIME_SEC] = LE.siteSettings.SlaUnitsSettings.convertOtherUnit2Sec(autoCloseTime, autoCloseUnit);

                this.trigger("sla:save", options);
            },
            _getSlaUnitsOptions: function() {
                var slaUnitsList = LE.siteSettings.SlaUnitsSettings.getSlaUnitsListTranslated();
                return new Dropdown.Collection(slaUnitsList);
            },
            _getSelectedDefaultSlaUnits: function() {
                return this.settingsCollection.get(Settings.SETTING_ID.DEFAULT_SLA_UNITS).getValue();
            },
            _getSelectedUrgentSlaUnits: function() {
                return this.settingsCollection.get(Settings.SETTING_ID.URGENT_SLA_UNITS).getValue();
            },
            _getSelectedFirstTimeSlaUnits: function() {
                return this.settingsCollection.get(Settings.SETTING_ID.FIRST_TIME_SLA_UNITS).getValue();
            },
            _getSelectedDefaultSla: function() {
                return this.settingsCollection.get(Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME).getValue();
            },
            _getSelectedUrgentSla: function() {
                return this.settingsCollection.get(Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME).getValue();
            },
            _getSelectedFirstTimeSla: function() {
                return this.settingsCollection.get(Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME).getValue();
            },
            _getSelectedAutoCloseTime: function() {
                var autoCloseInSec = this.settingsCollection.get(Settings.SETTING_ID.AUTO_CLOSE_TIME_SEC).getValue();
                var autoCloseToShow = LE.siteSettings.SlaUnitsSettings.convertSec2OtherUnit(autoCloseInSec);

                return autoCloseToShow.time;
            },
            _getSelectedAutoCloseUnits: function() {
                var autoCloseInSec = this.settingsCollection.get(Settings.SETTING_ID.AUTO_CLOSE_TIME_SEC).getValue();
                var autoCloseToShow = LE.siteSettings.SlaUnitsSettings.convertSec2OtherUnit(autoCloseInSec);

                return autoCloseToShow.unit;
            }

        });
    });
    return SLAEditView;

});

